import { Button } from "antd";
import styled from "styled-components";

export const Content = styled.div`
  background-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e5e5;
  padding: 20px;
  border-radius: 8px;
  color: #032e68;

  transition: box-shadow 0.25s;

  &:hover {
    box-shadow: 0 3px 4px -1px rgba(0, 0, 0, 0.1);
  }
`;

export const Title = styled.div`
  font-size: 18px;
`;

export const Description = styled.div`
  margin: 16px 0;
`;

export const ViewButton = styled(Button)`
  border-radius: 4px;
  padding: 6px 24px;
  height: auto;
  color: #032e68;
  border: 1px solid #032e68;
  box-shadow: none;
  font-size: 15px;
`;
